import { skipToken, useQuery } from '@tanstack/react-query';

import { Clips } from '@air/api';
import { callAirApi } from '@air/utils-api';

export const PRIVATE_CLIP_TRANSCRIPT_KEY = 'PRIVATE_CLIP_TRANSCRIPT';

export type UseGetPrivateClipTranscriptParams = {
  clipId: string | undefined;
  workspaceId: string | undefined;
};

export type PrivateClipTranscriptKey = [typeof PRIVATE_CLIP_TRANSCRIPT_KEY, UseGetPrivateClipTranscriptParams];

export const getPrivateClipTranscriptKey = (params: UseGetPrivateClipTranscriptParams): PrivateClipTranscriptKey => [
  PRIVATE_CLIP_TRANSCRIPT_KEY,
  params,
];

export type UseGetPrivateClipTranscriptOptions = {
  enabled?: boolean;
};

export const useGetPrivateClipTranscript = (
  params: UseGetPrivateClipTranscriptParams,
  options?: UseGetPrivateClipTranscriptOptions,
) => {
  const { clipId, workspaceId } = params;

  return useQuery({
    queryKey: getPrivateClipTranscriptKey(params),
    queryFn: !clipId || !workspaceId ? skipToken : () => callAirApi(() => Clips.getTranscript({ clipId, workspaceId })),
    enabled: !!clipId && !!workspaceId && options?.enabled,
  });
};
